import { createAction, props } from '@ngrx/store';
import { HomeDataDto } from 'src/app/data/dtos';
import { IuserApplicationsAndJobs } from 'src/app/data/interfaces';

export const getHomeData = createAction(
  '[Dashboard] getHomeData',
  props<{ activeLanguage: string }>(),
);
export const getHomeDataSuccess = createAction(
  '[Dashboard] getHomeDatasuccess',
  props<HomeDataDto>(),
);
export const getHomeDataAlreadyLoaded = createAction(
  '[Dashboard] getHomeDataAlreadyLoaded success',
  props<HomeDataDto>(),
);
export const addAppliedJobsToHomeData = createAction(
  '[Dashboard] addAppliedJobsToHomeData success',
  props<IuserApplicationsAndJobs>(),
);
export const removeAppliedJobsToHomeData = createAction(
  '[Dashboard] removeAppliedJobsToHomeData success',
  props<IuserApplicationsAndJobs>(),
);
export const getHomeDataFailure = createAction(
  '[Dashboard] getHomeData failure',
  props<{ error: string }>(),
);

export const resetHomeData = createAction('[Dashboard] resetHomeData');
